import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    header: {
        backgroundColor: '#fff',
        color: '#173300',
        borderBottom: '1px solid #E6E6E6',
        margin: '32px auto 16px',
    },
    section: {
        backgroundColor: '#fff',
        marginBottom: theme.spacing(2) + 'px',
        padding: theme.spacing(2) + 'px',
        borderRadius: 10,
    },
    card: {
        border: '1px solid #E6E6E6',
        borderRadius: 10,
        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
    },
    image: {
        width: 44,
        height: 44,
        borderRadius: 8,
        objectFit: 'cover',
    },
    input: {
        backgroundColor: '#F9FAFB',
        borderRadius: 6,
    },
    saveButton: {
        backgroundColor: '#9EE870',
        color: '#173300',
        marginTop: theme.spacing(1) + 'px',
        '&:hover': { backgroundColor: '#8BD35F' },
    },
    actionButtonContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(1) + 'px',
    },
    importActionButton: {
        flex: 1,
        borderColor: '#173300',
        color: '#173300',
        position: 'relative',
        zIndex: 1
    },
    importFreemiumIcon: {
        position: 'absolute',
        right: 0,
        top: 0,
        width: '20px',
        height: '20px',
        display: 'inline-block',
        padding: '4px',
        zIndex: 2
    },
}));

export default useStyles;
